// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"Md-z","title":"Nd-z","nav":"Od-z","flexCell":"Pd-z","facetLink":"Qd-z"};